<template>
	<v-container fluid align-start ma-0 pa-2 class="container-height">
		<v-row no-gutters fill-height>
			<v-col cols="12">
				<i-card-vertical :headerTitle="menuTitle" 				 
				>
					<template v-slot:body>
						<v-row no-gutters>
							<v-col cols="12" class="pa-0">
								<v-row no-gutters>
								<v-col class="pb-1">
									<i-card-top
									class="d-md-flex"
									outlined
									:useBtnList="useBtnList"																		
									@btnRetrieve="btnRetrieve()" @btnSave="btnSave()"
        
									>
									<template v-slot:body>
										<v-layout column>
											<v-row no-gutters class="center pa-2 pb-2">
												<i-label :label="'Ship  No :'" />
												<v-col cols="1">
													<v-select
													v-model=" shipNo"
													:items="shipNoList"
													single-line
													outlined
													dense
													height="32"
													@change="getLotNo()"
													/>
												</v-col>
												<i-label :label="' Lot No :'" class="pl-2"/>
												<v-col cols="1">
													<v-select
													v-model="lotNo"
													:items="lotNoList"
													outlined
													dense
													height="32"
													@change="getCutGrp()"
													/>
												</v-col>
												<i-label :label="' Cut Group :'" class="pl-2"/>
												<v-col cols="1">
													<v-select
													v-model="cutGrp"
													:items="cutGrpList"
													outlined
													dense
													height="32"													
													/>
												</v-col>

												<i-label :label="' Steel Kind :'" class="pl-2"/>
												<v-col cols="1">
													<v-select
													v-model="steelKind"
													:items="steelKindList"
													return-object
													item-value="code"
													item-text="codeName"
													outlined
													dense
													height="32"													
													/>
												</v-col>
											</v-row>
											<v-row  dense class="ma-0">
												<i-label :label="'Input Date:'" class="pl-2" />
												<v-col cols="2">
													<DxDateBox
													:value="inputDte"
													height="32px"
													display-format="yyyy-MM-dd"
													:acceptCustomValue="false"
													@value-changed="e => {inputDte = e.value && getStrFormat(e.value)}"
													/>
												</v-col>
												<i-label :label="' Machine :'" class="pl-2"/>
												<v-col cols="1">
													<v-select
													v-model="machine"
													:items="machineList"
													return-object
													item-value="machId"
													item-text="machNm"
													outlined
													dense
													height="32"													
													/>
												</v-col>
												<i-label :label="' Cutter PIC :'" class="pl-2"/>
												<v-col cols="2">
													<v-select
													v-model="cutter"
													:items="cutterList"
													return-object
													item-value="code"
													item-text="codeName"
													outlined
													dense
													height="32"													
													/>
												</v-col>
											</v-row>
										</v-layout>										
									</template>
									</i-card-top>
								</v-col>
							   </v-row>
							</v-col>
						</v-row>						
						<v-row>
							<!--  Reservation List ---------------------------------------------------------------------------- -->
							<v-col cols="2" class="pa-1">								
								<v-row no-gutters>
									<v-col cols="12" class="pt-1">
										<DxDataGrid id="epmsa230List" 
											:ref="epmsa230ListRef"
											class="hipGridHeight1_1"
											:data-source="epmsa230List" 
											:remote-operations="false" 
											:hover-state-enabled="true"
											:allow-column-resizing="true" 
											:allow-column-reordering="true"
											:row-alternation-enabled="true" 
											:show-borders="true" 
											:width="grid.width"
											:show-row-lines="true" 
											key-expr="id" 
											:focused-row-enabled="true"
											:focused-row-key= "rowIndex" 
											:auto-navigate-to-focused-row="true"	
											:column-hiding-enabled="false" 
											:sorting="{ mode: 'none' }"
											:selection="{ mode: 'none' }"
											:word-wrap-enabled="true"
											@cellPrepared="cellPrepared"
											@focused-row-changed="onFocusedRowChanged"
										> 

											<DxColumn data-field="shipNo" caption="Ship no" width="25%" data-type="string" alignment="center" :allow-editing="false"/>
											<DxColumn data-field="lotNo" caption="Lot No" width="20%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="lotNo"/>
											<template #lotNo>
												<div>Lot<br>No</div>
											</template>
											<DxColumn data-field="cutGrp" width="20%" data-type="string" alignment="center" :allow-editing="false" cell-template="cutGrpCell" header-cell-template="cutGrp"/>
											<template #cutGrp>
												<div>Cut<br>Group</div>
											</template>
											<template #cutGrpCell="{ data : cellInfo }">	
												<v-layout>
													{{cellInfo.value}}
													<v-icon v-if="cellInfo.data.visIcon1" small class="mt-n1" color="blue">
														mdi-checkbox-marked-circle											
													</v-icon>	
													<v-icon v-if="cellInfo.data.visIcon2" small class="mt-n1" color="red">
														mdi-checkbox-marked-circle											
													</v-icon>														
												</v-layout>																																																										
											</template>
											<DxColumn data-field="pcsQty" width="18%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="pcsQty"/>
											<template #pcsQty>
												<div>PCS<br>Qty</div>
											</template>
											<DxColumn data-field="cutQty" width="18%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="cutQty"/>
											<template #cutQty>
												<div>Cut<br>Qty</div>
											</template>
											<DxPaging :enabled="false" :page-size="12" />
											<DxPager :visible="false" :showInfo="false" />
										</DxDataGrid>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="10" class="pa-1">
								<!-- End of Reservation List --------------------------------------------------------------------- -->
								<v-row no-gutters>
									<v-col cols="12">
										
										<v-row no-gutters>
											<v-col cols="12" class="pt-1" v-if = "visHeadLotH == false">
												<DxDataGrid id="epmsa230Head" 
													:ref="epmsa230HeadRef"
													class="doubleListBox08"
													:data-source="epmsa230Head" 
													:remote-operations="false" 
													:hover-state-enabled="true"
													:allow-column-resizing="true" 
													:allow-column-reordering="true"
													:row-alternation-enabled="true" 
													:show-borders="true" 
													:width="grid.width"
													:show-row-lines="true" 
													key-expr="id" 
													:focused-row-enabled="true"
													:focused-row-key= "rowIndex02" 
													:auto-navigate-to-focused-row="true"
													:column-hiding-enabled="false" 
													:sorting="{ mode: 'none' }"
													:selection="{ mode: 'none' , allowSelectAll: false }"
													:word-wrap-enabled="true"
													@focused-row-changed="onFocusedRowChangedHead"
												> 
												<DxColumn data-field="chk" data-type="boolean" width="3%" alignment="center" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
												<template #selHeader = "{ data: cellInfo }" >
													<DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)" :visible="visSelAll"  />
												</template>
												<template #selChkRow = "{ data: cellInfo }">
													<v-layout>
														<DxCheckBox :value="cellInfo.value === 'Y' ? true : false"
																	:onValueChanged="value => onValueChanged2(value, cellInfo)" 
																	:visible="cellInfo.data.visCheck" 
																	/>
														<v-icon v-if="cellInfo.data.visIcon" small class="mt-n1" color="red">
															mdi-checkbox-marked-circle											
														</v-icon>
													</v-layout>													
												</template> 

													<DxColumn data-field="lotNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="lotNo"/>
													<template #lotNo>
														<div>Lot<br>No</div>
													</template>
													<DxColumn data-field="cutGrp" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="cutGrp"/>
													<template #cutGrp>
														<div>Cut<br>Group</div>
													</template>
													<DxColumn data-field="dwgNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="dwgNo"/>
													<template #dwgNo>
														<div>Drawing<br>Page</div>
													</template>
													<DxColumn data-field="pcsQty" caption="Quantity" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="weight" caption="Weight" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="cutDay" caption="Mid PSD" width="10%" data-type="date" format="yy-MM-dd" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="cutDte" caption="Cutting Date" width="10%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="cutMakerId" caption="Cutting Maker" width="10%" data-type="string" alignment="center" :allow-editing="false" />																																							
													<DxColumn data-field="machNm" caption="Machine" width="10%" data-type="string" alignment="center" :allow-editing="false"/>

													<DxPaging :enabled="false" :page-size="12" />
													<DxPager :visible="false" :showInfo="false" />
												</DxDataGrid>
											</v-col>
											<v-col cols="12" class="pt-1" v-else>
												<DxDataGrid id="epmsa230Head" 
													:ref="epmsa230HeadRef"
													class="doubleListBox08"
													:data-source="epmsa230Head" 
													:remote-operations="false" 
													:hover-state-enabled="true"
													:allow-column-resizing="true" 
													:allow-column-reordering="true"
													:row-alternation-enabled="true" 
													:show-borders="true" 
													:width="grid.width"
													:show-row-lines="true" 
													key-expr="id" 
													:focused-row-enabled="true"
													:focused-row-key= "rowIndex02" 
													:auto-navigate-to-focused-row="true"
													:column-hiding-enabled="false" 
													:sorting="{ mode: 'none' }"
													:selection="{ mode: 'none' , allowSelectAll: false }"
													:word-wrap-enabled="true"
													@focused-row-changed="onFocusedRowChangedHead"
												> 
												<DxColumn data-field="chk" data-type="boolean" width="3%" alignment="center" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
												<template #selHeader = "{ data: cellInfo }" >
													<DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)" :visible="visSelAll"  />
												</template>
												<template #selChkRow = "{ data: cellInfo }">
													<v-layout>
														<DxCheckBox :value="cellInfo.value === 'Y' ? true : false"
																	:onValueChanged="value => onValueChanged2(value, cellInfo)" 
																	:visible="cellInfo.data.visCheck" 
																	/>
														<v-icon v-if="cellInfo.data.visIcon" small class="mt-n1" color="red">
															mdi-checkbox-marked-circle											
														</v-icon>
													</v-layout>													
												</template> 

													<DxColumn data-field="cutMakerId" caption="Cutting Maker" width="10%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="cutDay" caption="Mid PSD" width="10%" data-type="date" format="yy-MM-dd" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="cutDte" caption="Cutting Date" width="10%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="assyNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="assyNo"/>
													<template #assyNo>
														<div>WO<br>No</div>
													</template>
													<DxColumn data-field="pcsNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="pcsNo"/>
													<template #pcsNo>
														<div>WO<br>Seq</div>
													</template>
													<DxColumn data-field="dwgNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="dwgNo"/>
													<template #dwgNo>
														<div>Drawing<br>Page</div>
													</template>
													<DxColumn data-field="shipNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="shipNo"/>
													<template #shipNo>
														<div>Use<br>Ship</div>
													</template>
													<DxColumn data-field="lotNo" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="lotNo"/>
													<template #lotNo>
														<div>Use<br>Lot</div>
													</template>
													<DxColumn data-field="cutGrp" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="cutGrp"/>
													<template #cutGrp>
														<div>Cut<br>Group</div>
													</template>
													
													<DxColumn data-field="pcsQty" caption="Quantity" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="weight" caption="Weight" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
																																							
													<DxColumn data-field="machNm" caption="Machine" width="10%" data-type="string" alignment="center" :allow-editing="false"/>

													<DxPaging :enabled="false" :page-size="12" />
													<DxPager :visible="false" :showInfo="false" />
												</DxDataGrid>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<!-- End of Reservation Detail List --------------------------------------------------------------    -->
								<v-row no-gutters>
									<v-col cols="12" class="pt-4">										
										<v-row no-gutters>
											<v-col cols="12" class="pt-1">
												<DxDataGrid id="epmsa230Detail" 
													:ref="epmsa230DetailRef"
													class="doubleListBox08"
													:data-source="epmsa230Detail" 
													:remote-operations="false" 
													:hover-state-enabled="true"
													:allow-column-resizing="true" 
													:allow-column-reordering="true"
													:row-alternation-enabled="true" 
													:show-borders="true" 
													:width="grid.width"
													:show-row-lines="true" 
													key-expr="id" 
													:focused-row-enabled="true"
													:focused-row-key= "rowIndex02" 
													:column-hiding-enabled="false" 
													:sorting="{ mode: 'none' }"
													:selection="{ mode: 'none' , allowSelectAll: false }"
													:word-wrap-enabled="true"
												> 													
													<DxColumn data-field="cutMakerId" caption="Cutting Maker" width="8%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="cutDay" caption="Mid PSD" width="7%" data-type="date" format="yy-MM-dd" alignment="center" :allow-editing="false" />													
													<DxColumn data-field="cutDte" caption="Cutting Date" width="8%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" />													
													<DxColumn data-field="cutGrp" width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="cutGrp"/>
													<template #cutGrp>
														<div>Cut<br>Group</div>
													</template>
													<DxColumn data-field="keySer" caption="No" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="block" caption="Block"  width="5%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="mixBlk" width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="mixBlk"/>
													<template #mixBlk>
														<div>Mix<br>Block</div>
													</template>
													<DxColumn data-field="newLotGbn" width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="newLotGbn"/>
													<template #newLotGbn>
														<div>Assy<br>LOT</div>
													</template>

													<DxColumn data-field="stlLot" width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="stlLot"/>
													<template #stlLot>
														<div>Steel<br>LOT</div>
													</template>

													<DxColumn data-field="dwgNo" width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="dwgNo"/>
													<template #dwgNo>
														<div>Drawing<br>Page</div>
													</template>

													<DxColumn data-field="nextAssy"  width="6%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="nextAssy"/>
													<template #nextAssy>
														<div>Next<br>ASSY</div>
													</template>
													
													<DxColumn data-field="assyNo" caption="ASSY"  width="6%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="pcsNo"  caption="PCS"   width="5%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="pcsType"  caption="Specification"   width="15%" data-type="string" alignment="center" :allow-editing="false" />

													<DxColumn data-field="assyStg"  width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="assyStg"/>
													<template #assyStg>
														<div>ASSY<br>Stage</div>
													</template>

													<DxColumn data-field="cutStg"  width="5%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="cutStg"/>
													<template #cutStg>
														<div>Cut<br>Stage</div>
													</template>

													<DxColumn data-field="pcsQty"  caption="Qty"   width="4%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="weight"  caption="Weight"   width="6%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="pcsArea"  caption="Area"   width="5%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="cutNo"  caption="Cutting Order No"   width="12%" data-type="string" alignment="center" :allow-editing="false" />
													<DxColumn data-field="machNm"  caption="Machine"   width="8%" data-type="string" alignment="center" :allow-editing="false" />
													<DxPaging :enabled="false"  />
													<DxPager :visible="false" :showInfo="false" />
												</DxDataGrid>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</i-card-vertical>
			</v-col>
		</v-row>
	</v-container>
</template>
	
<script>
import { DxDataGrid, DxEditing, DxColumn , DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { epmsa230List, epmsa230Head, epmsa230Detail, epmsa230Machine, epmsa230save, epmsa230cancel } from '@/api/view/hip/A/epmsa230.js'
import { reportView , getSysDate} from '@/api/view/hip/common/common.js'
import { getShipNoList } from '@/api/view/hip/A/epmsa010_kl'
import { epmsa220LotNo,epmsa220CutGrp } from '@/api/view/hip/A/epmsa220'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getDateFormat , getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify' // message

export default {
	name: 'epmsa230',
	mixins: [baseview, BaseDataGrid],
	components: {
	ICardVertical,
	"i-card-top": iCardTop,
	DxDataGrid,
	DxColumn,
	DxEditing,
	DxDateBox,
	DxLookup,
	DxSelection,
	DxPager
},
	data() {
		return {
			menuTitle: this.$route.meta.title,
			useBtnList: ['btnRetrieve','btnSave'],
			

			epmsa230ListRef: 'epmsa230ListRef',
			epmsa230HeadRef: 'epmsa230HeadRef',
			epmsa230DetailRef: 'epmsa230DetailRef',
			epmsa230List: [],
			epmsa230Head: [],
			epmsa230Detail: [],

			makerCd: this.$store.state.user.makerCd,
			machine: '',
      		machineList: [],
			cutter: '',
			cutterList: [],
			steelKind: '',
      		steelKindList: [],
			shipNo: '',
			shipNoList: [],
			lotNo: '',
			lotNoList: [],
			cutGrp: '',
			cutGrpList: [],
			inputDte: getCurrentDate(),
			rowIndex : 0,
			rowIndex02 : 0,
			visSelAll : false,
			check : false,
			visHeadLotH : false
		}
	},
	computed: {
		gridMainInstance() {
			return this.GetDataGrid(this.epmsa230ListRef)
		},
		gridMainInstance2() {
			return this.GetDataGrid(this.epmsa230HeadRef)
		},
		gridMainInstance3() {
			return this.GetDataGrid(this.epmsa230DetailRef)
		},		
	},
	mounted() {
		this.init()
		this.gridMainInstance.option('defaultPaging', false)
		this.gridMainInstance2.option('defaultPaging', false)
		this.gridMainInstance3.option('defaultPaging', false)
	},
	methods: {
		getStrFormat(date) {
			return getDateFormat(date)
		},
		init(){
			this.facDivRList = []
			this.getList()
		},
		async getList(){
			try {
				this.openLoading('searching')
				let param = {
				makerCd: this.makerCd
				}

				await getCmChildCode({
				code: '',
				codegr: '',
				prtCode: 'STEEL_KIND',
				userFlag: 'Y'
				}).then(res => {
				this.steelKindList = res.list
				this.steelKind = this.steelKindList[2]
				//console.log(this.steelKindList);
				
				})			
				
				await getCmChildCode({
				code: '',
				codegr: '',
				prtCode: 'CUTTER',
				userFlag: 'Y'
				}).then(res => {
				this.cutterList = res.list
				this.cutter = this.cutterList[0]			
				})			
				//this.cutterList.splice(0,0, {code : '', codeName : ''})
				//console.log(cutterList)
				
				await getShipNoList(param).then(res => {
				this.shipNoList.push('Select')
				res.list.forEach(e => {
					this.shipNoList.push(e.shipNo)
				});
				this.shipNo = this.shipNoList[0]           
				})

				await epmsa230Machine(param).then(res => {
				
				res.list.forEach(e => {
					this.machineList.push({machId : e.machId, machNm : e.machNm})
				});
				console.log(this.machineList)
				console.log(res)
				this.machine = this.machineList[0]           
				})
			} finally {
				this.getLotNo()
				this.getCutGrp()

				this.endLoading()
			}
		},
		async getLotNo(){
			this.lotNoList = []
			let param = {        
				shipNo: this.shipNo == 'Select' ? '' : this.shipNo,
				div: '230'
			}
			await epmsa220LotNo(param).then(res => {
				this.lotNoList.push('')
				res.list.forEach(e => {
				this.lotNoList.push(e.useLotNo)
				});
				this.lotNo = this.lotNoList[0]
			})
			},
		async getCutGrp(){
		this.cutGrpList = []
		let param = {        
			shipNo: this.shipNo == 'Select' ? '' : this.shipNo,
			lotNo: this.lotNo
		}
		await epmsa220CutGrp(param).then(res => {
			this.cutGrpList.push('')
			res.list.forEach(e => {
			this.cutGrpList.push(e.useCutGrp)
			});
			this.cutGrp = this.cutGrpList[0]
		})
		},
		async getMain(){
			this.epmsa230List = []
			try {
				this.openLoading('searching')
				let param = {
					shipNo: this.shipNo,
					userId: this.makerCd,
					lotNo : !this.lotNo ? '': this.lotNo ,
					cutGrp : !this.cutGrp ? '': this.cutGrp,
					steelKind : this.steelKind.code
				}				
				await epmsa230List(param).then(res => {
					let cnt = 0;
					if(res.list.length){
						res.list.forEach(e => {
							//console.log(e)
							e.id = cnt++
							e.visIcon1 = e.pcsQty === e.cutQty && e.pcsQty === e.cnfQty ? true : false;
							e.visIcon2 = e.pcsQty === e.cutQty && e.pcsQty !=  e.cnfQty ? true : false;
							this.epmsa230List.push(e);
						});
						//this.epmsa230List = res.list						
											
					}
				})
			}finally {
				this.endLoading()
			}
		},
		async getMain2(shipNo, lotNo, cutGrp){
			this.epmsa230Head = []
			try {
				this.openLoading('searching')
				let param = {
					shipNo: shipNo,					
					lotNo : lotNo ,
					cutGrp : cutGrp
				}				
				await epmsa230Head(param).then(res => {
					let cnt = 0;
					let chkVis = 0;
					if(res.list.length){
						res.list.forEach(e => {
							//console.log(e)
							e.id = cnt++
							if(e.cutCnfYn === 'N' )
								chkVis ++;
							
							e.visCheck = e.cutCnfYn === 'Y' && e.cutWgt >=  e.weight ? false : true;
							e.visIcon   = e.cutCnfYn === 'Y' && e.cutWgt >=  e.weight ? true : false;

							this.epmsa230Head.push(e);
						});
						if(chkVis > 0)
							this.visSelAll = true;

						//this.epmsa230Head = res.list																	
					}
				})
			}finally {
				this.endLoading()
			}
		},
		async getMain3(shipNo, lotNo, cutGrp, dwgPage, steelKind){
			this.epmsa230Detail = []
			try {
				this.openLoading('searching')
				let param = {
					shipNo: shipNo,					
					lotNo : lotNo ,
					cutGrp : cutGrp,
					dwgPage : dwgPage,
					steelKind : steelKind
				}		
				console.log(param)		
				await epmsa230Detail(param).then(res => {
					let cnt = 0;
					if(res.list.length){
						res.list.forEach(e => {
							//console.log(e)
							e.id = cnt++
						});
						this.epmsa230Detail = res.list																	
					}
				})
			}finally {
				this.endLoading()
			}
		},
		btnRetrieve(){
			
			this.getMain().finally(() => {
            if (!this.epmsa230List.length ) {                   
				 this.epmsa230Head = []
				 this.epmsa230Detail = []

                } else {
					this.rowIndex = 0
                    					
                }
            })
			
		},
		onFocusedRowChanged(e) {
			this.rowIndex = e.component.option('focusedRowKey');	
			
			let shipNo = e.row.data.shipNo
			let lotNo = e.row.data.lotNo
			let cutGrp = e.row.data.cutGrp

			if(lotNo.substring(0,1) == "H"){
				this.visHeadLotH = true
			}else{
				this.visHeadLotH = false
			}

			this.getMain2(shipNo, lotNo, cutGrp)			
			 .finally(() => {
				
				if (!this.epmsa230Head.length) {                   
					
					//this.epmsa230Detail = []

					} else {
						this.rowIndex02 = 0
						
						let shipNo = this.epmsa230Head[0].shipNo
						let lotNo = this.epmsa230Head[0].lotNo
						let cutGrp = this.epmsa230Head[0].cutGrp
						let dwgPage = this.epmsa230Head[0].dwgNo
						let steelKind = this.steelKind.code

						this.getMain3(shipNo, lotNo, cutGrp, dwgPage, steelKind)
					}
					
            })
			
		},

		onFocusedRowChangedHead(e) {
			this.rowIndex02 = e.component.option('focusedRowKey');	
			
			let shipNo = e.row.data.shipNo
			let lotNo = e.row.data.lotNo
			let cutGrp = e.row.data.cutGrp
			let dwgPage = e.row.data.dwgNo
			let steelKind = this.steelKind.code

			this.getMain3(shipNo, lotNo, cutGrp, dwgPage, steelKind)
			
		},
		
		weighTotal(col){
			let total = 0;
			if(!this.epmsa230Head.length)
				return;
			
			this.epmsa230Head.forEach(e => {
				if(col === "sum_hmd_wgt"){
					 total += e.weight;
				}else if(col === "sum_wgt"){
					 total += e.cutWgt;
				}
			})		
			
			return total;

		},

		async btnSave() {
			this.check = true
			await this.gridMainInstance2.saveEditData()
			 var row = await this.gridMainInstance2.getSelectedRowsData()			

			if (!row.length) {
				this.vToastify(this.$t('You not select data to save!!!'), 'warn')
				return
			}

			if(!this.cutter){
				this.vToastify(this.$t('Data is not selected for cutting PIC.!!!'), 'warn')
				return
			}

			if(!this.machine){
				this.vToastify(this.$t('Data is not selected for cutting machine.!!!'), 'warn')
				return
			}

			let lotNo = this.epmsa230List[this.rowIndex].lotNo ;   
						

			row.forEach(e => {
				if(!e.cutMakerId || e.cutMakerId.trim() == "" ){ // Maker Code
					this.vToastify(this.$t('Select cutting maker.!!!'), 'warn')
					this.check = false
					return;
				}
				if(!e.cutDte || e.cutDte.trim() == "" ){
					this.vToastify(this.$t('Input cutting date!!!'), 'warn')
					this.check = false
					return;
				}
				
				if (lotNo.substring(0,1 )!= "H"){
					console.log("sum_hmd_wgt" + this.weighTotal("sum_hmd_wgt"))
					console.log("sum_wgt" + this.weighTotal("sum_wgt"))
					if(e.cutYn == "Y" && this.weighTotal("sum_hmd_wgt") <= this.weighTotal("sum_wgt")){
						this.vToastify(this.$t('Already Cutted!!!'), 'warn')
						this.check = false
						return;	
					}

				}else{

					if(e.cutYn == "Y"){
						this.vToastify(this.$t('Already Cutted!!!'), 'warn')
						this.check = false
						return;	
					}
				}		
				e.cutDte = e.cutDte.replace(/-/g, "")						
				e.userId = this.$store.state.user.userId
				e.cutMakerId = this.$store.state.user.userId
				e.machId = this.machine.machId
				e.picEmpNo = this.cutter.code
			});			
			//console.log(row)
			if(this.check == true){
				try {
					this.openLoading('searching')
					epmsa230save(row).then(res => {
						if(res.body === 'Y'){
							notify(this.$t('Saving is completed.'), 'success', 3000)
							this.getMain()
							
						} else {
							this.vToastify(this.$t(res.body), 'warn')
						}
					})
					.catch(error => {
						this.endLoading()
					})
				} finally {
					this.endLoading()
				}
			}					
			
		},
		async btnCancel(){
			
			// await this.gridMainInstance2.saveEditData()
			// var selectedMainRows = await this.gridMainInstance2.getSelectedRowsData()

			// if (!selectedMainRows.length) {
			// 	this.vToastify(this.$t('Data not select!'), 'warn')				
			// 	return				
			// }

			// for(var row of selectedMainRows){			
			// 	row.userId = this.$store.state.user.userId				
			// }
			// console.log(row)
			// try {
			// 	this.vToastifyPrompt(
			// 		this.$t('Do you want to cancel for selected rows?'),
			// 		'info',
			// 		current => {
			// 			epmsa230cancel(selectedMainRows).then(res => {
			// 				if(res.body === 'Y'){
			// 					notify(this.$t('Cancel is completed.'), 'success', 3000)
			// 					this.getMain()								
			// 				} else {
			// 					this.vToastify(this.$t(res.body), 'warn')
			// 				}
			// 			})
			// 			.catch(error => {
			// 				this.endLoading()
			// 			})
			// 		},
			// 		null,
			// 		true
			// 	)
			// } finally {
			// 	this.endLoading()
			// }
		},
		
		cellPrepared(e){
			if(e.rowType === 'data'){
				e.cellElement.style.cursor = 'pointer'
			}
		},
		onValueChanged(value, cellInfo){
		console.log(cellInfo)
		for(let i = 0; i < this.epmsa230Head.length; i++) {    
			this.epmsa230Head[i].chk = value.value        
				if(value.value === true) {
				this.gridMainInstance2.selectRows(i, true)
				this.epmsa230Head[i].chk = 'Y'    
				this.epmsa230Head[i].cutMakerId = this.makerCd           
				this.epmsa230Head[i].cutDte = this.inputDte           
				} else {
				this.gridMainInstance2.deselectRows(i, true)  
				this.epmsa230Head[i].chk = 'N'  
				this.epmsa230Head[i].cutMakerId = ''           
				this.epmsa230Head[i].cutDte = ''
				}
				this.gridMainInstance2.updateDimensions()
		}
      
    },

		onValueChanged2(value, cellInfo){
		if(cellInfo.data.chk == 'N') {
			this.epmsa230Head[cellInfo.data.id].chk = 'Y'      
			this.gridMainInstance2.selectRows(cellInfo.data.id, true) 
			this.epmsa230Head[cellInfo.data.id].cutMakerId = this.makerCd
			this.epmsa230Head[cellInfo.data.id].cutDte = this.inputDte   
		} else {        
			this.epmsa230Head[cellInfo.data.id].chk = 'N'
			this.gridMainInstance2.deselectRows(cellInfo.data.id, true) 
			this.epmsa230Head[cellInfo.data.id].cutMakerId = null
			this.epmsa230Head[cellInfo.data.id].cutDte = null
		}
		this.gridMainInstance2.updateDimensions()
		}
	}
}
</script>
<style lang="scss" scoped>
</style>